import { Box, Stack } from '@mui/material';
import { LineChart } from '@mui/x-charts';
import { Text } from 'mbd-components/text';

export function MetricBox({metric, dates, dataset, highlightedValue}) {

  // const dates = ['2025-04-01', '2025-04-02', '2025-04-03', '2025-04-04', '2025-04-05', '2025-04-06', '2025-04-07', '2025-04-08', '2025-04-09', '2025-04-10', '2025-04-11', '2025-04-12', '2025-04-13', '2025-04-14', '2025-04-15', '2025-04-16', '2025-04-17', '2025-04-18', '2025-04-19', '2025-04-20', '2025-04-21', '2025-04-22', '2025-04-23', '2025-04-24', '2025-04-25', '2025-04-26', '2025-04-27', '2025-04-28', '2025-04-29', '2025-04-30'];
  // const data = Array.from({ length: 30 }, () => Math.floor(Math.random() * (2000 - 500 + 1)) + 500);

  return (
    <Box display="flex" flexDirection='column' sx={{borderWidth: 2, borderColor: '#776666', borderRadius: 2, px: 2, py:1}}>
      {/* <Stack direction='column'> */}
      <Stack direction='row' justifyContent='center' alignItems='center' spacing={1}>
        <Text variant='small' color='gray' sx={{fontWeight: 'bold'}}>{metric}</Text>
        <Text variant='h1' color='brand-light' sx={{mx:2}}>{highlightedValue}</Text>
      </Stack>

        <LineChart
          series={[{data:dataset, color: '#776666',showMark: dates.length > 1 ? false : true}]}
          height={70}
          xAxis={[{ 
            scaleType: 'point', 
            data: dates, 
            disableTicks: true, 
            disableLine: true, 
            position:'none', 
            tickInterval: (value) => '',
            min: dates.length === 1 ? -1 : undefined,  // Add padding on left for single point
            max: dates.length === 1 ? 1 : undefined    // Add padding on right for single point
          }]}
          yAxis={[{ tickVisible: false, axisLine: false, position:'none', disableLine: true, disableTicks: true }]}
          grid={{ horizontal: false, vertical: false }}
          margin={{ top: 0, bottom: 0, left: 0, right: 0 }}
          sx={{
            '.MuiLineElement-root': {
              strokeWidth: 2,
            },
          }}
        />

      {/* </Stack> */}

    </Box>
  );
}